import actions from '../../actions/BenefitsSetIdentifiers'
import connectIndex from '../../lib/connectIndex'
import BulkIdentifierComponent from '../common/BulkIdentifierComponent'

export default connectIndex(
  BulkIdentifierComponent,
  'benefitsSetIdentifiers',
  actions,
  [],
  {
    indexParams: { product_line: 'large_group_custom' },
    redirectTo: '/large_group_custom_benefits/bulk'
  }
)
